<template>
  <figure ref="preview_content" class="preview__content">

    <div v-if="getWidth() != '100%'">
      <iframe ref="preview" class="preview__frame" name="parkave-preview" scrolling :srcdoc="preview.srcdoc" :style="`width: ${getWidth()}; height: ${getHeight()};`"></iframe>
    </div>

    <div v-if="getWidth() == '100%'" class="browser browser__container">
      <div class="browser__row">
        <div class="browser__column browser__left">
          <span class="browser__dot" style="background:#ED594A;"></span>
          <span class="browser__dot" style="background:#FDD800;"></span>
          <span class="browser__dot" style="background:#5AC05A;"></span>
        </div>
        <div class="browser__column browser__middle">
          <input type="text" value="https://www.yourwebsite.com" disabled="true">
        </div>
        <div class="browser__column browser__right">
          <div style="float:right">
            <span class="browser__bar"></span>
            <span class="browser__bar"></span>
            <span class="browser__bar"></span>
          </div>
        </div>
      </div>

      <div class="browser__content">
        <iframe ref="preview" name="parkave-preview" class="preview__frame" scrolling :srcdoc="preview.srcdoc" :style="`width: ${getWidth()}; height: ${getHeight()};`"></iframe>
      </div>
    </div>
  </figure>
</template>

<script>
  import { getPreview }  from '../../lib/api/calls';

  export default {
    name: 'preview-settings',
    props: ['ad', 'inputs', ''],
    computed: {

    },
    mounted () {
      this.generatePreview()
    },
    methods: {
      getWidth() {
        if (this.inputs.size && this.inputs.size.width) {
          if (this.inputs.size.type == 'fixed') {
            return this.inputs.size.width + 'px';
          } else if (this.inputs.size.type == 'flexible' && this.$refs.preview_content) {
            return this.$refs.preview_content.offsetWidth * .9 + 'px';
          }
        } else {
          // out of page
          return '100%';
        }
      },
      getHeight() {
        if (this.inputs.size && this.inputs.size.height) {
          if (this.inputs.size.type == 'fixed') {
            return this.inputs.size.height + 'px';
          } else if (this.inputs.size.type == 'flexible' && this.$refs.preview_content) {
            let ratio = this.inputs.size.height / this.inputs.size.width;
            return this.$refs.preview_content.offsetWidth * ratio * .9 + 'px';
          }
        } else {
            //out of page
          return '100%';
        }
      },
      generatePreview() {
        if(this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(function(){
            this._generatePreview()
          }.bind(this), 300);
      },
      _generatePreview () {
        let { format_id } = this.$route.params;
        let scaleX = 1, scaleY = 1, scale = 0;

        if (!format_id) {
          format_id = this.ad.format_id;
        }

        let updateParent = () => {
          this.$emit('preview-data', {
            scale: parseInt(scale * 100)
          })
        }

        getPreview(format_id, this.inputs).then((res)=>{
          let length = res.headers.get("Content-Length");
          this.$set(this.preview, 'length', length);
          return res.text();
        }).then((html)=>{
          //this.$refs.preview.contentWindow.document.body.style.visibility = 'hidden';
          html = `<style>html{height:100%;}body{margin:0;padding:0;transform-origin:center center;height:100%;}</style>${html}`
          this.$set(this.preview, 'srcdoc', html);

          // now give it time to render
          setTimeout(() => {
            // width
            if (this.$refs.preview_content.offsetWidth < this.$refs.preview.contentWindow.document.body.offsetWidth) {
              var target_width = this.$refs.preview_content.offsetWidth * .90;
              scaleX = target_width / this.$refs.preview.contentWindow.document.body.offsetWidth;
            }

            // height
            if (this.$refs.preview_content.offsetHeight < this.$refs.preview.contentWindow.document.body.offsetHeight) {
              var target_height = this.$refs.preview_content.offsetHeight * .90;
              scaleY = target_height / this.$refs.preview.contentWindow.document.body.offsetHeight;
            }

            if (scaleX < scaleY) {
              scaleY = 1;
            } else if (scaleY < scaleX) {
              scaleX = 1;
            }

            scale = Math.min(scaleX, scaleY);

            this.$refs.preview.contentWindow.document.body.style.transition = 'all .5s ease-in-out';
            this.$refs.preview.contentWindow.document.body.style.transform = `scale(${scale})`;
            this.$refs.preview.contentWindow.document.body.style.tranformOrigin = 'center top 0px';

            // this.$refs.preview.contentWindow.document.body.style.visibility = 'visible';
            updateParent()
          }, 250)

          updateParent()
        });
      }
    },
    data(){
      return {
        value: null,
        preview: {
          srcdoc: '',
          length: 0
        }
      }
    },
    watch: {
      inputs: {
        deep: true,
        handler(newVal) {
          this.generatePreview()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/PreviewSettings.vue